import React from "react";
export default function TrashIcon({ color = "" }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      width="16px"
      height="16px"
    >
      <path
        fill={color || "currentColor"}
        d="M10 2 9 3H4v2h16V3h-5l-1-1h-4zM5 7v13c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V7H5zm3 2h2v11H8V9zm6 0h2v11h-2V9z"
      />
    </svg>
  );
}
